export default __webpack_public_path__ + "static/media/videoPlay.929b5c45.svg";